// extracted by mini-css-extract-plugin
export var chart = "styles-module--chart--5968c";
export var inner = "styles-module--inner--13d91";
export var wrapper = "styles-module--wrapper--b4ff4";